import React from "react";

const SiteName = ({ row }) => {
  return <div>{row?.site?.siteName}</div>;
};

export default SiteName;
